import Icon from "../../Icon/Icon";

const SkillCard = ({name, cssClass}) => {
  return (
      <li className={`skillCard bg-nfr-color-200 dark:bg-nfr-color-800 ${cssClass}`}>
        <div className={'skillIcon'}>
          <Icon name={name}></Icon>
        </div>
        <small>{name}</small>
      </li>
  )
}

export default SkillCard
